module.exports = __webpack_public_path__ + "static/media/branding_h48px.d92a7b5a.svg";